<template>
  <div class="management-page-outer-container">
    <router-view />
    <reservation-templates-list
      v-if="$route.name === 'reservation-templates'"
      :search-from-parent="search"
      @update-search="search = $event"
    >
      <management-add-button
        :label="$t('AddTemplate')"
        @buttonClick="$router.push({ name: 'reservation-template-create' })"
        :disabled="
          !userHasManagementPermission('asset_reservation_template', 'store')
        "
        :list-missing-permissions="[]"
      />
    </reservation-templates-list>
  </div>
</template>

<script>
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

import ManagementAddButton from "@/components/Management/ManagementAddButton";
import ReservationTemplatesList from "./ReservationTemplatesList";

export default {
  name: "ReservationTemplatesPage",

  components: {
    ReservationTemplatesList,
    ManagementAddButton
  },

  mixins: [checkPermissionsMixin],

  data() {
    return {
      /**
       * Save the value of the last search
       */
      search: ""
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AssetReservationManagement/Templates/ReservationTemplates.vue